import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-darkest.css
var $e5b9ee4a968dfaea64b1b8cf98dc184$exports = {};
$e5b9ee4a968dfaea64b1b8cf98dc184$exports = {
  "spectrum--darkest": "_spectrum--darkest_acf7f"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-global.css
var $feb906e4032856f299caea9c$exports = {};
$feb906e4032856f299caea9c$exports = {
  "spectrum": "_spectrum_5be2e",
  "spectrum--medium": "_spectrum--medium_5be2e",
  "spectrum--large": "_spectrum--large_5be2e",
  "spectrum--darkest": "_spectrum--darkest_5be2e",
  "spectrum--dark": "_spectrum--dark_5be2e",
  "spectrum--light": "_spectrum--light_5be2e",
  "spectrum--lightest": "_spectrum--lightest_5be2e"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-large.css
var $a43560ac21eb0f39f37bdbcf14c4bbb1$exports = {};
$a43560ac21eb0f39f37bdbcf14c4bbb1$exports = {
  "spectrum--large": "_spectrum--large_38267"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-lightest.css
var $f3a0f520b5f11addf4f11074f6666f0$exports = {};
$f3a0f520b5f11addf4f11074f6666f0$exports = {
  "spectrum--lightest": "_spectrum--lightest_05988"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-medium.css
var $dc84ce727b320e037f29b6ab6c663$exports = {};
$dc84ce727b320e037f29b6ab6c663$exports = {
  "spectrum--medium": "_spectrum--medium_24f04"
};
var $feb906e4032856f299caea9c$$interop$default = $parcel$interopDefault($feb906e4032856f299caea9c$exports);
var $f3a0f520b5f11addf4f11074f6666f0$$interop$default = $parcel$interopDefault($f3a0f520b5f11addf4f11074f6666f0$exports);
var $e5b9ee4a968dfaea64b1b8cf98dc184$$interop$default = $parcel$interopDefault($e5b9ee4a968dfaea64b1b8cf98dc184$exports);
var $dc84ce727b320e037f29b6ab6c663$$interop$default = $parcel$interopDefault($dc84ce727b320e037f29b6ab6c663$exports);
var $a43560ac21eb0f39f37bdbcf14c4bbb1$$interop$default = $parcel$interopDefault($a43560ac21eb0f39f37bdbcf14c4bbb1$exports);
export let theme = {
  global: $feb906e4032856f299caea9c$$interop$default,
  light: $f3a0f520b5f11addf4f11074f6666f0$$interop$default,
  dark: $e5b9ee4a968dfaea64b1b8cf98dc184$$interop$default,
  medium: $dc84ce727b320e037f29b6ab6c663$$interop$default,
  large: $a43560ac21eb0f39f37bdbcf14c4bbb1$$interop$default
};
//# sourceMappingURL=module.js.map
